import Route from '@ember/routing/route';

export default class SkiInstructorRoute extends Route {
  model(params) {
    return params;
  }

  setupController(controller, model) {
    super.setupController(controller, model);
    controller.loadInstructorTask.perform();
    controller.setProperties({
      instructor_id: model.id,
    });
  }

  resetController(controller) {
    controller.loadInstructorTask.cancelAll();
  }
}
